import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    Inject,
    Input,
    Optional,
    Output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DatiqAppStateService } from '@dat/datiq-app/data';
import { DatiqButtonModule } from '@dat/datiq-components-pkg/button';
import { DatiqTooltipModule } from '@dat/datiq-components-pkg/tooltip';
import { IDatiqAction } from '@dat/datiq-core/models';
import { noop } from 'lodash';
import { IDatiqCellActionService, datiqCellActionToken } from '../models';
import { IDatiqCellAction } from './models';

@Component({
    selector: 'datiq-cell-action',
    standalone: true,
    imports: [CommonModule, MatIconModule, MatButtonModule, DatiqButtonModule, DatiqTooltipModule],
    templateUrl: './datiq-cell-action.component.html',
    styleUrls: ['./datiq-cell-action.component.scss'],
})
export class DatiqCellActionComponent {
    @Input() settings: IDatiqCellAction;

    @Output() actionClicked: EventEmitter<IDatiqAction> =
        new EventEmitter<IDatiqAction>();

    constructor(
        @Optional()
        @Inject(datiqCellActionToken)
        private _service?: IDatiqCellActionService,
        @Optional() private _app?: DatiqAppStateService
    ) {}

    clicked(action: IDatiqAction): void {
        !!this._service
            ? this._service.fireAction(action)
            : !!this._app
            ? this._app.fireAction(action)
            : noop();
        this.actionClicked.emit(action);
    }
}
